const SS_TAGS_STORAGE_KEY = 'SS_TAGS_V1';

export const ssTags = {
  _read() {
    try { return JSON.parse(localStorage.getItem(SS_TAGS_STORAGE_KEY) || '{}'); }
    catch (e) { return {}; }
  },
  _write(obj) {
    try { localStorage.setItem(SS_TAGS_STORAGE_KEY, JSON.stringify(obj)); } catch (e) {}
  },
  key(product, variantDetailId, frequency) {
    const pid = product?.productId || product?.campaignProductId || product?.id || 'p';
    const vid = Number(variantDetailId) || 0;
    const freq = frequency || 'OT';
    return `${pid}|${vid}|${freq}`;
  },
  get(sig) {
    const all = this._read();
    return all[sig] || null;
  },
  set(sig, value) {
    const all = this._read();
    all[sig] = value;
    this._write(all);
  },
  del(sig) {
    const all = this._read();
    if (sig in all) {
      delete all[sig];
      this._write(all);
    }
  }
};

export const findMatchingVariant = (subscribeProduct, oneTimeVariant) => {
  const list = subscribeProduct?.variants || [];
  if (!list.length) return null;
  if (oneTimeVariant?.variantDetailId) {
      const byId = list.find(v => v.variantDetailId === oneTimeVariant.variantDetailId);
      if (byId) return byId;
  }
  if (oneTimeVariant?.title) {
      const byTitle = list.find(v => v.title === oneTimeVariant.title);
      if (byTitle) return byTitle;
  }
  return list[0];
};

export const getIconType = (icon) => {
    const iconSplit = icon?.split("|") || []
    return iconSplit.length > 1 ? (iconSplit[0] || "standard") : "standard"
}

export const updateIconType = (icon, type) => {
  const iconSplit = icon?.split("|") || []
  if (iconSplit.length > 1) {
    iconSplit[0] = type
    return iconSplit.join("|")
  }
  return `${type}|${icon}|`
}

export const getSVGIcon = (icon) => {
  const iconSplit = icon?.split("|") || []
  if (iconSplit.length > 1) {
    return iconSplit[2]
  }
  return icon 
}

export const getStandardIcon = (icon) => {
  const iconSplit = icon?.split("|") || []
  if (iconSplit.length > 1) {
    return iconSplit[1]
  }
  return icon 
}

export const isCombinedIconValue = (icon) => {
  return ["svg", "standard"].includes(icon?.split("|")?.[0]);
}

export const updateIconValue = (type, currentIcon, newIcon) => {
    const iconSplit = currentIcon?.split("|") || []
    if (iconSplit.length > 1) {
        iconSplit[0] = type
        if (type === 'svg') {
            iconSplit[1] = getStandardIcon(currentIcon) || "";
            iconSplit[2] = newIcon || "";
        } else {
            iconSplit[1] = newIcon || "";
            iconSplit[2] = getSVGIcon(currentIcon) || "";
        }
        return iconSplit.slice(0, 3).join("|")
    }
    return type === 'svg' ? `${type}|${getStandardIcon(currentIcon) || ""}|${newIcon || ""}` : `${type}|${newIcon || ""}|${getSVGIcon(currentIcon) || ""}`
}

export const replaceWithRegexMap = (text, replacements) => {
  let result = text;

  replacements.forEach(({ regex, replaceWith }) => {
    result = result.replace(regex, replaceWith);
  });

  return result;
};

export const getWebsitePrimaryColor = () => {
  return window.CURRENT_WEBSITE?.primary_color;
};

export const getDefaultButtonStyles = (buttonStyle) => {
  const primaryColor = getWebsitePrimaryColor();
  if (buttonStyle === "secondary") {
    return {
      button_color: "rgb(255, 255, 255)",
      button_title_color: primaryColor,
      button_border_color: primaryColor
    }
  }
  return {
    button_color: primaryColor,
    button_title_color: "rgb(255, 255, 255)",
    button_border_color: primaryColor
  }
};

export const CART_DRAWER_BUTTON_COLOR_CONSTANTS = [
  {
    label: "Button Color",
    key: "button_color",
    property: "background-color"
  },
  {
    label: "Button Title Color",
    key: "button_title_color",
    property: "color"
  },
  {
    label: "Button Border Color",
    key: "button_border_color",
    property: "border-color"
  }
];

export const CART_DRAWER_SUB_AND_SAVE_CONSTANTS = [
  {
    label: "Background Color",
    key: "background_color",
    defaultValue: "#f9f9f9"
  },
  {
    label: "Border Color",
    key: "border_color",
    defaultValue: "#e0e0e0"
  },
  {
    label: "Text Color",
    key: "text_color",
    defaultValue: "#333"
  },
  {
    label: "Badge Background Color",
    key: "badge_color",
    defaultValue: "#f9f9f9"
  },
  {
    label: "Badge Text Color",
    key: "badge_text_color",
    defaultValue: getWebsitePrimaryColor()
  },
  {
    label: "Price Color",
    key: "price_color",
    defaultValue: "#222"
  }
];

export const CART_DRAWER_SLIDER_CONSTANTS = [
  {
    label: "Text Color",
    key: "cart_threshold_slider_text_color",
    defaultValue: "#000",
    componentType: "color"
  },
  {
    label: "Background Color",
    key: "cart_threshold_slider_background_color",
    defaultValue: "#fff",
    componentType: "color"
  },
  {
    label: "Border",
    key: "cart_threshold_slider_border_type",
    defaultValue: "square",
    componentType: "select",
    options: [
      {
        value: "square",
        label: "Square"
      },
      {
        value: "rounded",
        label: "Rounded"
      }
    ]
  },
  {
    label: "Border Color",
    key: "cart_threshold_slider_border_color",
    defaultValue: "#fff",
    componentType: "color"
  },
  {
    label: "Icon Color",
    key: "cart_threshold_slider_icon_color",
    defaultValue: getWebsitePrimaryColor(),
    componentType: "color"
  },
  {
    label: "Icon Background Color",
    key: "cart_threshold_slider_icon_background_color",
    defaultValue: "#fff",
    componentType: "color"
  },
  {
    label: "Slider Line Color",
    key: "cart_threshold_slider_color",
    defaultValue: getWebsitePrimaryColor(),
    componentType: "color"
  }
];

export const CART_DRAWER_RECOMMENDATIONS_STYLE_CONSTANTS = [
  {
    label: "Heading Text Color",
    key: "cart_recommendation_heading_text_color",
    defaultValue: "#252525",
    componentType: "color"
  },
  {
    label: "Background Color",
    key: "cart_recommendation_background_color",
    defaultValue: "#ffffff00",
    componentType: "color"
  },
  {
    label: "Border Color",
    key: "cart_recommendation_border_color",
    defaultValue: "#dee2e6",
    componentType: "color"
  },
  {
    label: "Border",
    key: "cart_recommendation_border_type",
    defaultValue: "square",
    componentType: "select",
    options: [
      {
        value: "square",
        label: "Square"
      },
      {
        value: "rounded",
        label: "Rounded"
      }
    ]
  },
  {
    label: "Product Title Text Color",
    key: "cart_recommendation_product_title_text_color",
    defaultValue: "#252525",
    componentType: "color"
  },
  {
    label: "Price Color",
    key: "cart_recommendation_price_color",
    defaultValue: "#252525",
    componentType: "color"
  },
  {
    label: "Compare At Price Color",
    key: "cart_recommendation_compare_at_price_color",
    defaultValue: "#666666",
    componentType: "color"
  },
  {
    label: "Button Color",
    key: "cart_recommendation_button_color",
    defaultValue: getWebsitePrimaryColor(),
    componentType: "color"
  },
  {
    label: "Button Title Color",
    key: "cart_recommendation_button_title_color",
    defaultValue: "#fff",
    componentType: "color"
  },
  {
    label: "Button Border Color",
    key: "cart_recommendation_button_border_color",
    defaultValue: getWebsitePrimaryColor(),
    componentType: "color"
  }
];

export const CART_DRAWER_STYLE_CONSTANTS = [
  {
    label: "Text Color",
    key: "cart_drawer_text_color",
    defaultValue: "#000000",
    componentType: "color"
  },
  {
    label: "Line Color",
    key: "cart_drawer_line_color",
    defaultValue: getWebsitePrimaryColor(),
    componentType: "color"
  },
  {
    label: "Background Color",
    key: "cart_drawer_background_color",
    defaultValue: "#fff",
    componentType: "color"
  },
  {
    label: "Left Border Color",
    key: "cart_drawer_border_color",
    defaultValue: "#fff",
    componentType: "color"
  },
];

export const CART_DRAWER_PRODUCTS_STYLE_CONSTANTS = [
  {
    label: "Background Color",
    key: "cart_drawer_product_background_color",
    defaultValue: "#fff",
    componentType: "color"
  },
  {
    label: "Border",
    key: "cart_drawer_product_border_type",
    defaultValue: "rounded",
    componentType: "select",
    options: [
      {
        value: "square",
        label: "Square"
      },
      {
        value: "rounded",
        label: "Rounded"
      }
    ]
  },
  {
    label: "Border Color",
    key: "cart_drawer_product_border_color",
    defaultValue: "rgb(224, 224, 224)",
    componentType: "color"
  },
  {
    label: "Price Color",
    key: "cart_drawer_product_price_color",
    defaultValue: "#000000",
    componentType: "color"
  },
  {
    label: "Text Color",
    key: "cart_drawer_product_text_color",
    defaultValue: "#000000",
    componentType: "color"
  },
  {
    label: "Subtext Color",
    key: "cart_drawer_product_subtext_color",
    defaultValue: "#000000",
    componentType: "color"
  },
  {
    label: "Remove Button Color",
    key: "cart_drawer_product_remove_button_color",
    defaultValue: "#fa6160",
    componentType: "color"
  }
];
